import { APP_VERSION, VUE_VERSION, WORKBENCH_VERSION } from '@/../versions';

export type OWCFE = {
  version: string;
  vueVersion: string;
  wbVersion: string;
  build: string | undefined;
  initializedNamepaces: Set<string>;
};

declare global {
  interface Window {
    owcfe: OWCFE;
  }
}

window.owcfe = window.owcfe || {};
window.owcfe.version = APP_VERSION;
window.owcfe.vueVersion = VUE_VERSION;
window.owcfe.wbVersion = WORKBENCH_VERSION;
window.owcfe.build = process.env.VUE_APP_BUILD_TIMESTAMP;
